import React from "react";
import { twMerge } from "tailwind-merge";

interface GoalsSidebarSkeletonProps {
  skeletonClassName?: string;
}

export const GoalsSidebarSkeleton: React.FC<GoalsSidebarSkeletonProps> = ({
  skeletonClassName = "bg-bg-pressed/40",
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between border-b px-3 min-h-12">
        <div className="flex items-center gap-2">
          <div className={twMerge("h-4 w-4 rounded-sm animate-pulse", skeletonClassName)} />
          <div className={twMerge("h-4 w-4 rounded-sm animate-pulse", skeletonClassName)} />
        </div>
        <div className="flex items-center gap-2">
          <div className={twMerge("h-4 w-4 rounded-sm animate-pulse", skeletonClassName)} />
          <div className={twMerge("h-4 w-24 rounded-sm animate-pulse", skeletonClassName)} />
          <div className={twMerge("h-4 w-4 rounded-sm animate-pulse", skeletonClassName)} />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        {[...Array(3)].map((_, i) => (
          <SkeletonDomainCard key={i} skeletonClassName={skeletonClassName} />
        ))}
      </div>
    </div>
  );
};

interface SkeletonDomainCardProps {
  skeletonClassName: string;
}

const SkeletonDomainCard: React.FC<SkeletonDomainCardProps> = ({ skeletonClassName }) => {
  return (
    <div>
      <div className="flex items-center gap-2 border-b border-border-disabled min-h-12 px-3 animate-pulse">
        <div className="flex shrink-0 items-center">
          <div className={twMerge("h-4 w-4 rounded-sm", skeletonClassName)} />
        </div>
        <div className={twMerge("h-4 w-20 rounded-sm", skeletonClassName)} />
        <div className={twMerge("h-4 w-32 rounded-sm flex-1")} />
        <div className={twMerge("h-4 w-4 rounded-sm shrink-0", skeletonClassName)} />
      </div>

      <div className="flex flex-col gap-2 border-b border-border-disabled py-2 px-3">
        {[...Array(2)].map((_, i) => (
          <SkeletonGoalRow key={i} skeletonClassName={skeletonClassName} />
        ))}
      </div>
    </div>
  );
};

interface SkeletonGoalRowProps {
  skeletonClassName: string;
}

const SkeletonGoalRow: React.FC<SkeletonGoalRowProps> = ({ skeletonClassName }) => {
  return (
    <div className="flex flex-col gap-2 animate-pulse">
      <div className="flex w-full items-center gap-2 rounded-sm py-0.5">
        <div className={twMerge("h-4 w-4 rounded-sm shrink-0", skeletonClassName)} />
        <div className={twMerge("h-4 w-32 rounded-sm shrink-0", skeletonClassName)} />
        <div className={twMerge("h-4 w-full")} />
        <div className={twMerge("h-4 w-4 rounded-sm shrink-0", skeletonClassName)} />
        <div className={twMerge("h-4 w-4 rounded-sm shrink-0", skeletonClassName)} />
      </div>

      <div className="flex flex-col gap-1 pl-5">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex items-center gap-2 rounded-sm py-0.5">
            <div className={twMerge("h-4 w-24 rounded-sm shrink-0", skeletonClassName)} />
            <div className={twMerge("h-4 w-full")} />
            <div className={twMerge("h-4 w-4 rounded-sm shrink-0", skeletonClassName)} />
            <div className={twMerge("h-4 w-4 rounded-sm shrink-0", skeletonClassName)} />
          </div>
        ))}
      </div>
    </div>
  );
};
